import React from 'react';

// types
import { CellNazwaRenderProps } from '../../types';

const CellNazwaRender = ({
  data
}: CellNazwaRenderProps): JSX.Element | null => {
  if (!data) return null;

  const { Nazwa, Indeks, Ean } = data;

  const renderItem = (item: string | null, bold: boolean = false) => {
    if (item === null || item === '') return null;

    return (
      <div
        title={item}
        className={`kategoria-towary-grid-cell-nazwa-render__item ${
          bold ? 'kategoria-towary-grid-cell-nazwa-render__item--bold' : ''
        }`}
      >
        {item}
      </div>
    );
  };

  return (
    <div className="kategoria-towary-grid-cell-nazwa-render">
      {renderItem(Nazwa, true)}
      {renderItem(Indeks)}
      {renderItem(Ean)}
    </div>
  );
};

export default CellNazwaRender;
